import { render, staticRenderFns } from "./ListStats.vue?vue&type=template&id=bfc7440c"
import script from "./ListStats.vue?vue&type=script&lang=js"
export * from "./ListStats.vue?vue&type=script&lang=js"
import style0 from "./ListStats.vue?vue&type=style&index=0&id=bfc7440c&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc7440c')) {
      api.createRecord('bfc7440c', component.options)
    } else {
      api.reload('bfc7440c', component.options)
    }
    module.hot.accept("./ListStats.vue?vue&type=template&id=bfc7440c", function () {
      api.rerender('bfc7440c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ListStats.vue"
export default component.exports